<template>
    <div>
        <modal class="new-modal-default" :name="modal_name" transition="nice-modal-fade" :delay="100" :width="650"
            :height="350" :pivot-y="0.5" :adaptive="true" :scrollable="false" style="pointer-events:inherit !important" 
            v-bind:click-to-close="false">
            <div class="v-modal-content" style="background-color: #ffffff !important;">
                <div class="v-modal-header">
                    <div></div>
                    <div>
                        <span class="v-modal-dialog-title v-modal-title">Select Product Name</span>
                    </div>
                    <div>
                        <span class="icon icon-close mr-2 text-white pointer close-left" @click="hideSelf"></span>
                    </div>
                </div>
                <div class="v-modal-body overflow-hidden">
                    <div class="v-modal-layout">
                        <div class="d-flex align-items-center justify-content-between flex-column mt-4 px-8">
                            <div class="w-100">
                                <input class="w-100 mb-2" type="text" v-model="search_key" @keyup="getProduts"
                                    placeholder="Search..." style="border-bottom: 1px solid #000; height: 2em;">
                                <div class="d-flex align-items-center justify-content-center fw-600 mt-10" style="font-size:16px;"
                                    v-if="productsOptions.length == 0">
                                    Product Names Not Found
                                </div>
                                <div class="d-flex align-items-center flex-column" id="option-list">
                                    <span class="pointer fs-14 fw-600 my-2" v-for="(option,index) in productsOptions"
                                        :key="index" @click="optionSelected(option)">{{ option.name }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>
<script>
    import globals from "../globals";
    export default {
        data() {
            return {
                productsOptions: [],
                isLoading: false,
                search_key: "",
                add_to_list: false,
            }

        },
        props: ["modal_name"],
        methods: {
            infinteScroll() {
                var scrollTop = document.getElementById('option-list').scrollTop;
                var scrollHeight = document.getElementById('option-list').scrollHeight;
                var offsetHeight = document.getElementById('option-list').offsetHeight;
                var clientHeight = document.getElementById('option-list').clientHeight;
                var contentHeight = scrollHeight - offsetHeight;
                if (contentHeight <= scrollTop) {
                    if (!this.infinite_scroll_reached_end) {
                        this.add_to_list = true;
                        this.getOptionsAfter();
                    }
                }
            },
            hideSelf() {
                this.$modal.hide(this.modal_name);
            },
            optionSelected(option) {
                this.$emit("selectedProduct", option);
                this.hideSelf()
            },
            async getProduts() {
                this.isLoading = true;
                let params = {
                    skip: 0,
                    limit: 10,
                    search: this.search_key,
                };
                let res = await this.$http.post(globals.SCM_API + "/fnb/scm/get_product_listing_data", params);
                if (res.data.status_id == 1) {
                    this.productsOptions = [];
                    if (res.data.products) {
                        res.data.products.forEach(x => {
                            if ("name" in x) {
                                this.productsOptions.push(x);
                            }
                        });
                        this.isLoading = false;
                    }
                }
            },
            async getProdutsAfter() {
                if (this.add_to_list && this.options.length >= 10) {
                    let params = {
                        skip: this.options.length,
                        limit: 10,
                        search: this.search_key,
                    };
                    let res = await this.$http.post(globals.SCM_API + "/fnb/scm/get_product_listing_data", params);
                    if (res.data.status_id == 1) {
                        if (res.data.products) {
                            res.data.products.forEach(x => {
                                if ("name" in x) {
                                    this.productsOptions.push(x);
                                }
                            });
                        }
                    }
                };
            },
        },
        mounted() {
            this.getProduts()
        }

    }
</script>


// WEBPACK FOOTER //
// src/components/alertModals/SelectProductSaleForecast.vue